module.exports = __webpack_public_path__ + "static/img/intro-tip.005b3dc9.png";